import {isoWindow} from '~/utils/window';

export function hasAnyInitScript(): boolean {
  if (
    typeof isoWindow === 'undefined' ||
    !isoWindow.Shopify ||
    !isoWindow.Shopify.SignInWithShop
  ) {
    return false;
  }

  const initScripts = [
    'initCustomerAccounts',
    'initCustomerAccountsSignUp',
    'initShopForNewCustomerAccounts',
  ];
  return initScripts.some(
    (scriptName) =>
      typeof isoWindow.Shopify.SignInWithShop[scriptName] === 'function',
  );
}
